import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import ViewLayout from "../../components/layouts/ViewLayout";
import CustomTable from "../../components/Table/CustomTable.component";
import { Fab, Grid, makeStyles, Tooltip } from "@material-ui/core";
import NewUserIcon from "../../components/IconsLibrary/NewUserIcon";

//#region Entity's dependencies
import { getEnterprises, modifyEnterprise } from "../../actions/enterprise.action";
import EnterpriseForm from "../enterprises/enterprisesForm.view";
import { messagesResponseEnterprises } from "../../utils/constants";
import { SET_ENTERPRISE_ERROR, GET_ENTERPRISE_CHANGED, GET_ENTERPRISEBYID } from "../../actions/types";
//#endregion

/**
 * Enterprises Component ( full view for list of Enterprises)
 *
 * @export Class Component
 * @class Enterprises
 * @extends {Component}
 * @returns Redux connect
 */
const useStyles = makeStyles((theme) => ({
  newUserIcon: {
    stroke: theme.palette.secondary.main,
  },
  styleFab: {
    boxShadow: "none",
  },
}));

const Enterprises = ({ component: Component, container, ...props }) => {
  const {
    records,
    getRecords,
    modifyRecord,
    recordChanged,
    currentEnterprise,
    recordErrorResponse,
    messagesResponse,
    GET_RECORD_CHANGED,
    SET_RECORD_ERROR,
    Loading
  } = props;
  const classes = useStyles();

  //#region States
  const [showRecordAlert, setShowRecordAlert] = useState(false);
  const [recordId, setRecordId] = useState(0);
  const [recordInfo, setRecordInfo] = useState({});
  const dispatch = useDispatch();
  const [confirmInactivate, setConfirmInactivate] = useState({
    open: false,
    item: "",
    name: "",
    checked: false,
    message: "",
  });
  const [isFormShowed, setFormShowed] = useState(false);
  const [option, setOption] = useState(0);
  let [isLoading, setLoading] = useState(false);
  if(Loading !== undefined){
    setLoading = Loading;
  }
  //#endregion

  //#region Effects
  useEffect(() => {
    if (!Array.isArray(recordChanged)) {
      setConfirmInactivate({
        open: true,
        message: recordChanged,
        item: "inactivate",
      });
      dispatch({
        type: GET_RECORD_CHANGED,
        payload: [],
      });
    }
    if (!Array.isArray(recordErrorResponse) && recordErrorResponse !== messagesResponse.notPermission) {
      setConfirmInactivate({
        open: true,
        message: recordErrorResponse,
        showBtnAccept: true,
        textButtonAccept: "Cerrar",
        item: "inactivate",
      });
      dispatch({
        type: SET_RECORD_ERROR,
        payload: [],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordChanged, dispatch, recordErrorResponse]);

  useEffect(() => {
      getRecords();
  }, [getRecords,isFormShowed]);

  useEffect(() => {
    if (!!records) {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [records]);
  //#endregion

  //#region custom
  const columns = [
    {
      id: "name",
      label: "Nombre empresa",
      minWidth: 40,
      haveDropDown: true,
      wordLength: 100,
    },
    {
      id: "createdon",
      label: "Fecha de creación",
      minWidth: 140,
      haveDropDown: true,
      format: (value) => {
        let splited = value.split("T")[0];
        let newDate = splited.split("-");
        return `${newDate[2]}/${newDate[1]}/${newDate[0]}`;
      },
    },
    {
      id: "idstate",
      label: "Estado",
      minWidth: 40,
      haveDropDown: true,
      align: "center",
      component: {
        handleChange: (e, value, id) => handleStateClick(e, value, id),
      },
      tooltipMessage: "empresa",
      withIcon: true,
      handleIconClick: (ev, id) => handleDeleteClick(ev, id),
      format: (value) => (value === 1 || value === false ? false : true),
    },
  ];

  /**
   * Manage the click event for of change state
   * @param {*} e
   * @param {*} id
   * @param {*} name
   */
  const handleStateClick = (e, id, name) => {
    setConfirmInactivate({
      open: true,
      item: id,
      name: name,
      showBtnAccept: true,
      showBtnCancel: true,
      checked: e.target.checked,
      message: `¿Está seguro que desea ${
        e.target.checked ? "activar" : "inactivar"
      }
      ${"esta empresa"}?`,
    });
  };

  /**
   * Manage the click event of the delete icon
   * @param {*} ev
   * @param {*} id
   */
   const handleDeleteClick = (ev, id) => {
    setConfirmInactivate({
      open: true,
      item: id,
      showBtnAccept: true,
      showBtnCancel: true,
      delete: true,
      message: '¿Deseas eliminar esta empresa?',
    });
  };

  /**
   * Manage the click event of the confirmation or not of the popup
   */
  const handleConfirmChecked = () => {
    let result = records.filter(
      (item) => item.id === confirmInactivate.item
    )[0];

    if(result){
      let recordToBeModified = {
            id: confirmInactivate.item,
            name: result.name,
            description: result.description,
            documenttypeid: result.documenttypeid,
            documentnumber: result.documentnumber,
            monitoringService: result.monitoringService,
            tracingService: result.tracingService,
            resourceService: result.resourceService,
            integrationService: result.integrationService,
            logService: result.logService,
            quequeService: result.quequeService,
            monitoringVersion: result.monitoringVersion,
            signatureSupplier: result.signatureSupplier,
            signatureURL: result.signatureURL,
            idstate: confirmInactivate.checked ? 0 : 1,
            createdby: result.createdby,
            createdon: result.createdon,
            modifiedby: result.modifiedby,
            idbusinessunit: result.idbusinessunit,
            idowner: result.idowner
          };
      console.log(confirmInactivate);
      if (confirmInactivate.name === "idstate") {
        recordToBeModified.idstate = confirmInactivate.checked ? 0 : 1;
        modifyRecord(
          recordToBeModified,
          updateChecked,
          true
        );
      } else if (confirmInactivate.delete) {
        recordToBeModified.idstate = 2;
        modifyRecord(
          recordToBeModified,
          updateChecked,
          true
        );
      }
    }
    setConfirmInactivate({
      ...confirmInactivate,
      open: false,
      item: "",
      checked: false,
      message: "",
    });
  };

  /**
   * Get the buttons definations of the custom table
   */
  const getButtons = () => {
    let button = {
      searchBar: {
        cellSize: {
          sm: 7,
          xs: 12,
        },
      },
      menuOrder: {
        options: [
          {
            label: "Activo",
            columns: [
              {
                prop: "idstate",
                direction: -1,
              },
            ],
          },
          {
            label: "Inactivo",
            columns: [
              {
                prop: "idstate",
              },
            ],
          },
          {
            label: "Más reciente",
            columns: [
              {
                prop: "createdon",
                direction: 1,
                format: (date) => {
                  return new Date(date).getTime();
                },
              },
            ],
          },
          {
            label: "Más antiguo",
            columns: [
              {
                prop: "createdon",
                direction: -1,
                format: (date) => {
                  return new Date(date).getTime();
                },
              },
            ],
          },
        ],
        cellSize: {
          sm: 2,
          xs: 2,
        },
      },
      children: () => {
        return (
          <Grid container item lg={12} md={12} sm={2} xs={2} direction="row-reverse">
              <Tooltip title={`Crear`} aria-label={`Nuevo`} >
                <Fab
                  size="small"
                  className={[classes.fab, classes.styleFab]}
                  onClick={() => {
                    setFormShowed(true);
                    setRecordId(0);
                    setRecordInfo({});
                  }}
                >
                  <NewUserIcon />
                </Fab>
              </Tooltip>
          </Grid>
        );
      },
    };

    return button;
  };

  /**
   * if record is updated, this method get records again
   */
  const updateChecked = (record) => {
      getRecords();
      if(record.id && record.id === currentEnterprise.id){
        dispatch({
          type: GET_ENTERPRISEBYID,
          payload: record,
        });
      }
  };

  /**
   * Manage the click event of the selected cell
   */
  const handleCellClick = (evt, row) => {
    setRecordId(row.id);
    setRecordInfo(row);
    setFormShowed(true);
    setLoading(true);
  };

  return (
    <ViewLayout
      headerTitle={"Empresas"}
      handleAccept={handleConfirmChecked}
      confirmInactivate={confirmInactivate}
      setConfirmInactivate={setConfirmInactivate}
      showAlert={showRecordAlert}
      setShowAlert={setShowRecordAlert}
      isLoading={isLoading}
    >
      {isFormShowed ? (
        <EnterpriseForm
          recordId={recordId}
          record={recordInfo}
          setRecordId={setRecordId}
          setCardState={setFormShowed}
          updateChecked={updateChecked}
          setLoading={setLoading}
          setShowRecordAlert={setShowRecordAlert}
        />
      ) : (
        <CustomTable
          columns={columns}
          data={records}
          mainParam={"name"}
          buttons={getButtons()}
          havePagination={true}
          handleCellClick={handleCellClick}
          option={option}
          setOption={setOption}
          paramToDisable={"idstate"}
        />
      )}
    </ViewLayout>
  );
};

//#endregion

//#region entities's declarations 
Enterprises.propTypes = {
  getRecords: PropTypes.func.isRequired,
  modifyRecord: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  records: state.enterpriseReducer.getEnterprisesResponse,
  recordChanged: state.enterpriseReducer.getEnterpriseChangedResponse,
  recordErrorResponse: state.enterpriseReducer.setEnterpriseErrorResponse,
  currentEnterprise: state.enterpriseReducer.getEnterpriseByIDResponse,
  messagesResponse: messagesResponseEnterprises,
  GET_RECORD_CHANGED: GET_ENTERPRISE_CHANGED,
  SET_RECORD_ERROR: SET_ENTERPRISE_ERROR
});

const mapDispatchToProps = {
  getRecords: getEnterprises,
  modifyRecord: modifyEnterprise
};

export default connect(mapStateToProps, mapDispatchToProps)(Enterprises);
//#endregion